'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const RelatedKeys = require('common/domain/value/related-keys');
const ToggleNavCollection = require('common/ui/view/toggle-nav/collection');
const ToggleNavListView = require('common/ui/view/toggle-nav/index');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');
const TaskCollectionRepository = require('communication/domain/repository/task-collection');
const TaskRelatedListView = require('communication/ui/view/task/related-list');
const TimelineView = require('balus/ui/view/timeline/index');
const AdditionalView = require('balus/ui/view/additional/index');
const Template = require('system/ui/template/detail/element-communication.hbs');

module.exports = Mn.View.extend({
    template: Template,
    className: 'element-communication',
    ui: {
        header: '.header'
    },
    regions: {
        content: '.content'
    },

    templateContext: function() {
        let title;
        if (this.model.key.kind === 'Record') {
            title = i18n.t('balus_template_body_diagram:content.detail.node.communication-header');
        } else if (this.model.key.kind === 'Relation') {
            title = i18n.t('balus_template_body_diagram:content.detail.link.communication-header');
        }
        return {
            title: title
        }
    },

    onRender: function () {
        // 未保存のElementに対するコメント、タスクは表示できない
        if (!this.model.key.kind) {
            return this;
        }

        const context = this.getOption('context');
        const project = context.getProject();
        const parentContent = this.getOption('parentContent');
        const navRegion = this.getOption('navRegion');

        this.ui.header.hide();

        Promise.all([
            CommentCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage(),
            TaskCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage()
        ])
            .then(values => {
                const comments = values[0];
                const tasks = values[1];

                const navs = new ToggleNavCollection([
                    {
                        id: 'detail',
                        icon: 'fa fa-info-circle',
                        label: 'diagram:content.detail',
                        active: true
                    },
                    {
                        id: 'timeline',
                        icon: 'fa fa-comments-o',
                        label: 'module/word:timeline',
                        badge: {
                            content: function () {
                                return comments.getTotalCount();
                            },
                            listen: function (onChange) {
                                comments.on('change:totalCount', onChange);
                            }
                        }
                    },
                    {
                        id: 'task',
                        icon: 'fa fa-check-square',
                        label: 'module/word:task',
                        badge: {
                            content: function () {
                                return tasks.getTotalCount();
                            },
                            listen: function (onChange) {
                                tasks.on('change:totalCount', onChange);
                            }
                        }
                    }
                ]);
                navRegion.show(new ToggleNavListView({
                    collection: navs,
                    horizontal: true
                }));

                navs.on('active', nav => {
                    const addContent = () => {
                        if(this.model.key.kind == 'Record') {
                            this.getChildView('content').addRecord(this.model);
                        } else {
                            this.getChildView('content').addRelation(this.model);
                        }
                    };

                    const relatedKeys = new RelatedKeys([context.get().key, this.model.key]);
                    this.ui.header.show();

                    if (nav.id == 'detail') {
                        this.getRegion('content').empty();
                        this.ui.header.hide();
                        parentContent.show();
                    }

                    if (nav.id == 'timeline') {
                        this.showChildView('content', new TimelineView({
                            model: this.model,
                            collection: comments,
                            context: context
                        }));

                        addContent();

                        parentContent.hide();
                        this.getChildView('content').on('comment:sent', () => {
                            addContent();
                        });
                    }

                    if (nav.id == 'task') {
                        this.showChildView('content', new TaskRelatedListView({
                            collection: tasks,
                            context: context,
                            AdditionalView: AdditionalView,
                            relatedKeys: relatedKeys
                        }));
                        parentContent.hide();
                    }
                });
            });
        return this;
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/detail/element-communication.js